import { render, staticRenderFns } from "./i18nLabelsTranslates.vue?vue&type=template&id=c1e7bebc"
import script from "./i18nLabelsTranslates.vue?vue&type=script&lang=js"
export * from "./i18nLabelsTranslates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports